
interface Props {
    label?: string;
    placeholder: string;
    defaultValue?: any;
    value?: any;
    id?: string;
    dataField: string;
    formData?: any;
    setStateMethod?: any;
    isPassword?: boolean;
    customLeftCols?: any; // for example col-sm-3
    customRightCols?: any; // for example col-sm-9
    justifyContent?: any;
}

export const TextBoxEmail = (props: Props) => {
    let leftColumnClass = `${props.customLeftCols ?? "col-sm-3"
        } col-form-label zvlabel`;

    let rightColumnClass = `${props.customRightCols ?? "col-sm-9"}`;

    let valueProps = props.value == undefined ? {} : {
        value: props.value
    };

    return <>
        <div
            className="row"
            style={{ justifyContent: props.justifyContent ?? "unset" }}
        >
            {props.label && (
                <label htmlFor={props.id} className={leftColumnClass}>
                    {props.label}
                </label>
            )}

            <div className={rightColumnClass}>
                <input id={props.id} type='email'
                    {...valueProps}
                    className={`form-control`} placeholder={props.placeholder ? props.placeholder : ''}
                    onChange={(event) => {
                        props.formData[props.dataField] = event.target.value;
                        if (props.setStateMethod) {
                            props.setStateMethod({ ...props.formData });
                        }
                    }}
                />
            </div>
        </div>
    </>
}